import React, { useEffect, useState } from 'react'

// UI
import {
  Box,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material'

// services
import { getSiteEvents as getSiteEventsData } from '../../../model'
import { useAppNavigate } from '../../../Paths'
import { EventViewModel } from '../../ViewModel'

interface SiteEventTableProps {
  siteId: string
}

const SiteEventsTable = ({ siteId }: SiteEventTableProps) => {
  const appNavigate = useAppNavigate()

  const [events, setEvents] = useState([])
  const [limitLoad, setLimitLoad] = useState<number | string>(10)

  useEffect(() => {
    console.log('Site Events Table starts to load')
    fetchSiteEvents()
  }, [limitLoad])

  const fetchSiteEvents = async () => {
    let siteEventsData: EventViewModel[] = []
    if (limitLoad == 'all') {
      siteEventsData = await getSiteEventsData(siteId)
    } else {
      siteEventsData = await getSiteEventsData(siteId, Number(limitLoad))
    }

    setEvents(siteEventsData)
  }

  const handleEventsLimitLoad = (e) => {
    setLimitLoad(e.target.value)
  }

  return (
    <>
      <Box sx={{ float: 'right' }}>
        <FormControl sx={{ m: 0, minWidth: 50 }} size="small">
          <Select
            variant="standard"
            sx={{ border: 1 }}
            label="Events"
            value={limitLoad}
            onChange={handleEventsLimitLoad}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={'all'}>all</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <TableContainer
        component={Paper}
        elevation={0}
        style={{ minWidth: 340, minHeight: 650, height: '70vh' }}
      >
        {/* id is used to generate pdf */}

        <Table stickyHeader id="subcollection-table">
          <TableHead>
            <TableRow>
              <TableCell>Creation Date</TableCell>
              <TableCell>Time of Record</TableCell>

              <TableCell>Water Level</TableCell>
              <TableCell>Sample Depth</TableCell>
              <TableCell>Water Temperature</TableCell>
              <TableCell>pH</TableCell>
              <TableCell>EC</TableCell>
              <TableCell>Turbidity</TableCell>
              <TableCell>Air Temperature</TableCell>

              <TableCell>Flow Observation</TableCell>
              <TableCell>Flow Rate</TableCell>
              <TableCell>Water Level Observation</TableCell>
              <TableCell>Water Notes</TableCell>

              <TableCell>Rainfall Observation</TableCell>
              <TableCell>Wind Observation</TableCell>
              <TableCell>Sky Observation</TableCell>

              <TableCell>Past Rainfall</TableCell>

              <TableCell>Lab Sample</TableCell>
              <TableCell>aBottle</TableCell>
              <TableCell>dBottle</TableCell>
              <TableCell>Flood Comments</TableCell>

              <TableCell>Site Notes</TableCell>

              <TableCell>Signal Index</TableCell>
              <TableCell>Poullution Index</TableCell>
              <TableCell>Catchment Index</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((item, index) => (
              <TableRow
                key={item.id.toString()}
                onClick={() => appNavigate.toEvent(siteId, item.id)}
                style={{
                  backgroundColor: index % 2 === 0 ? 'gainsboro' : 'white',
                }}
              >
                <TableCell>{item.creationDate}</TableCell>
                <TableCell>{item.timeOfRecord}</TableCell>

                <TableCell>{item.waterLevel}</TableCell>
                <TableCell>{item.sampleDepth}</TableCell>
                <TableCell>{item.waterTemp}</TableCell>
                <TableCell>{item.pH}</TableCell>
                <TableCell>{item.EC}</TableCell>
                <TableCell>{item.turbidity}</TableCell>
                <TableCell>{item.airTemp}</TableCell>

                <TableCell>{item.flowObservation}</TableCell>
                <TableCell>{item.flowRate}</TableCell>
                <TableCell>{item.waterlevelObservation}</TableCell>
                <TableCell>{item.waterNotes}</TableCell>

                <TableCell>{item.rainfallObservation}</TableCell>
                <TableCell>{item.windObservation}</TableCell>
                <TableCell>{item.skyObservation}</TableCell>

                <TableCell>{JSON.stringify(item.pastRainfall)}</TableCell>

                <TableCell>{item.labSample}</TableCell>
                <TableCell>{item.aBottle}</TableCell>
                <TableCell>{item.dBottle}</TableCell>
                <TableCell>{item.floodComments}</TableCell>

                <TableCell>{item.siteNotes}</TableCell>

                <TableCell>{item.signalIndex}</TableCell>
                <TableCell>{item.pollutionIndex}</TableCell>
                <TableCell>{item.catchmentIndex}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default SiteEventsTable
